<template>
  <div class="container">
    <h2 class="center-align">Echo API page</h2>
    <apiTest />
    <div class="divider"></div>
    <router-link to="/">Back to home</router-link>
  </div>
</template>

<script>
import apiTest from "../components/Main/ApiTest";
export default {
  components: {
    apiTest,
  },
};
</script>